import { useMemo } from 'react'
import { PermissionGrant, useUserPermissionGrantsQuery, Permission } from '../graphql'

export type PermissionsResult = {
  loading: boolean,
  userPermissions: PermissionGrant[],
}

export default function usePermissions( permissionsToCheck?: Permission[] ): PermissionsResult {
	const { loading, data } = useUserPermissionGrantsQuery( { variables: { permissions: permissionsToCheck } } )

	const userPermissions = useMemo( () => {
		if ( !loading && data?.userPermissionGrants ) {
			return data.userPermissionGrants
		}
		return []
	}, [ loading, data ] )

	return {
		loading,
		userPermissions,
	}
}
